import cl from 'classnames'

import Icon from '../../Icon/Icon'

import { Props } from './types'

import styles from './styles.module.scss'

const InfiniteScrollWrapper: React.FC<Props> = ({ data, wrapperClassName }) => (
	<div className={cl(styles.loaderWrapper, wrapperClassName)}>
		<Icon className={styles.logo} type="logo" />
		<div className={styles.text}>
			Loading {data?.from} to {data?.to}
		</div>
	</div>
)

export default InfiniteScrollWrapper
